import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import GetGroupedByStatusTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByStatusTaskListRequest';
import GetByStatusTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByStatusTaskListRequest';
import GetGroupedByPriorityTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByPriorityTaskListRequest';
import GetByPriorityTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByPriorityTaskListRequest';
import GetGroupedByPerformerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByPerformerTaskListRequest';
import GetByPerformerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByPerformerTaskListRequest';
import GetGroupedByTagTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByTagTaskListRequest';
import GetByTagTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByTagTaskListRequest';
import GetGroupedByTypeTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByTypeTaskListRequest';
import GetByTypeTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByTypeTaskListRequest';
import GetGroupedByOwnerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByOwnerTaskListRequest';
import GetByOwnerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByOwnerTaskListRequest';
import GetByParentTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByParentTaskListRequest';
import GetByIdRequest from '../../../projects/task/i-service/models/task/request/GetByIdRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import GetGroupedByStatusTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByStatusTaskListResponse';
import GetByStatusTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByStatusTaskListResponse';
import GetGroupedByPriorityTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByPriorityTaskListResponse';
import GetByPriorityTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByPriorityTaskListResponse';
import GetGroupedByPerformerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByPerformerTaskListResponse';
import GetByPerformerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByPerformerTaskListResponse';
import GetGroupedByTagTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByTagTaskListResponse';
import GetByTagTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByTagTaskListResponse';
import GetGroupedByTypeTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByTypeTaskListResponse';
import GetByTypeTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByTypeTaskListResponse';
import GetGroupedByOwnerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByOwnerTaskListResponse';
import GetByOwnerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByOwnerTaskListResponse';
import GetByParentTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByParentTaskListResponse';
import GetByIdResponse from '../../../projects/task/i-service/models/task/response/GetByIdResponse';

export default class ProjectTaskGetService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetGroupedByStatusTaskListEvent = new Events<WsResponseModelT<GetGroupedByStatusTaskListResponse>>();
	GetByStatusTaskListEvent = new Events<WsResponseModelT<GetByStatusTaskListResponse>>();
	GetGroupedByPriorityTaskListEvent = new Events<WsResponseModelT<GetGroupedByPriorityTaskListResponse>>();
	GetByPriorityTaskListEvent = new Events<WsResponseModelT<GetByPriorityTaskListResponse>>();
	GetGroupedByPerformerTaskListEvent = new Events<WsResponseModelT<GetGroupedByPerformerTaskListResponse>>();
	GetByPerformerTaskListEvent = new Events<WsResponseModelT<GetByPerformerTaskListResponse>>();
	GetGroupedByTagTaskListEvent = new Events<WsResponseModelT<GetGroupedByTagTaskListResponse>>();
	GetByTagTaskListEvent = new Events<WsResponseModelT<GetByTagTaskListResponse>>();
	GetGroupedByTypeTaskListEvent = new Events<WsResponseModelT<GetGroupedByTypeTaskListResponse>>();
	GetByTypeTaskListEvent = new Events<WsResponseModelT<GetByTypeTaskListResponse>>();
	GetGroupedByOwnerTaskListEvent = new Events<WsResponseModelT<GetGroupedByOwnerTaskListResponse>>();
	GetByOwnerTaskListEvent = new Events<WsResponseModelT<GetByOwnerTaskListResponse>>();
	GetByParentTaskListEvent = new Events<WsResponseModelT<GetByParentTaskListResponse>>();
	GetByIdEvent = new Events<WsResponseModelT<GetByIdResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectTaskGetService', 'GetGroupedByStatusTaskList', 'Main', (res: WsResponseModelT<GetGroupedByStatusTaskListResponse>) => {
			self.GetGroupedByStatusTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetByStatusTaskList', 'Main', (res: WsResponseModelT<GetByStatusTaskListResponse>) => {
			self.GetByStatusTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetGroupedByPriorityTaskList', 'Main', (res: WsResponseModelT<GetGroupedByPriorityTaskListResponse>) => {
			self.GetGroupedByPriorityTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetByPriorityTaskList', 'Main', (res: WsResponseModelT<GetByPriorityTaskListResponse>) => {
			self.GetByPriorityTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetGroupedByPerformerTaskList', 'Main', (res: WsResponseModelT<GetGroupedByPerformerTaskListResponse>) => {
			self.GetGroupedByPerformerTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetByPerformerTaskList', 'Main', (res: WsResponseModelT<GetByPerformerTaskListResponse>) => {
			self.GetByPerformerTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetGroupedByTagTaskList', 'Main', (res: WsResponseModelT<GetGroupedByTagTaskListResponse>) => {
			self.GetGroupedByTagTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetByTagTaskList', 'Main', (res: WsResponseModelT<GetByTagTaskListResponse>) => {
			self.GetByTagTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetGroupedByTypeTaskList', 'Main', (res: WsResponseModelT<GetGroupedByTypeTaskListResponse>) => {
			self.GetGroupedByTypeTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetByTypeTaskList', 'Main', (res: WsResponseModelT<GetByTypeTaskListResponse>) => {
			self.GetByTypeTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetGroupedByOwnerTaskList', 'Main', (res: WsResponseModelT<GetGroupedByOwnerTaskListResponse>) => {
			self.GetGroupedByOwnerTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetByOwnerTaskList', 'Main', (res: WsResponseModelT<GetByOwnerTaskListResponse>) => {
			self.GetByOwnerTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetByParentTaskList', 'Main', (res: WsResponseModelT<GetByParentTaskListResponse>) => {
			self.GetByParentTaskListEvent.trigger(res);
		});
		webApiService.on('ProjectTaskGetService', 'GetById', 'Main', (res: WsResponseModelT<GetByIdResponse>) => {
			self.GetByIdEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Получение сгруппированных задач по статусу
	 */
	async GetGroupedByStatusTaskList(request: GetGroupedByStatusTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByStatusTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по статусу
	 */
	async GetByStatusTaskList(request: GetByStatusTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByStatusTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по приоритету
	 */
	async GetGroupedByPriorityTaskList(request: GetGroupedByPriorityTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByPriorityTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по приоритету
	 */
	async GetByPriorityTaskList(request: GetByPriorityTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByPriorityTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по исполнителю
	 */
	async GetGroupedByPerformerTaskList(request: GetGroupedByPerformerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByPerformerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по исполнителю
	 */
	async GetByPerformerTaskList(request: GetByPerformerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByPerformerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по тегам
	 */
	async GetGroupedByTagTaskList(request: GetGroupedByTagTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByTagTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по тегу
	 */
	async GetByTagTaskList(request: GetByTagTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByTagTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по типу
	 */
	async GetGroupedByTypeTaskList(request: GetGroupedByTypeTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByTypeTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по типу
	 */
	async GetByTypeTaskList(request: GetByTypeTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByTypeTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по владельцам
	 */
	async GetGroupedByOwnerTaskList(request: GetGroupedByOwnerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByOwnerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по создателю
	 */
	async GetByOwnerTaskList(request: GetByOwnerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByOwnerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение задач по родителю
	 */
	async GetByParentTaskList(request: GetByParentTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByParentTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение детальной задачи
	 */
	async GetById(request: GetByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение сгруппированных задач по статусу
	 */
	async getGroupedByStatusTaskListAsync(request: GetGroupedByStatusTaskListRequest): Promise<GetGroupedByStatusTaskListResponse> {
		return new Promise<GetGroupedByStatusTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByStatusTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByStatusTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByStatusTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по статусу
	 */
	async getByStatusTaskListAsync(request: GetByStatusTaskListRequest): Promise<GetByStatusTaskListResponse> {
		return new Promise<GetByStatusTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByStatusTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByStatusTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByStatusTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по приоритету
	 */
	async getGroupedByPriorityTaskListAsync(request: GetGroupedByPriorityTaskListRequest): Promise<GetGroupedByPriorityTaskListResponse> {
		return new Promise<GetGroupedByPriorityTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByPriorityTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByPriorityTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByPriorityTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по приоритету
	 */
	async getByPriorityTaskListAsync(request: GetByPriorityTaskListRequest): Promise<GetByPriorityTaskListResponse> {
		return new Promise<GetByPriorityTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByPriorityTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByPriorityTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByPriorityTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по исполнителю
	 */
	async getGroupedByPerformerTaskListAsync(request: GetGroupedByPerformerTaskListRequest): Promise<GetGroupedByPerformerTaskListResponse> {
		return new Promise<GetGroupedByPerformerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByPerformerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByPerformerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByPerformerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по исполнителю
	 */
	async getByPerformerTaskListAsync(request: GetByPerformerTaskListRequest): Promise<GetByPerformerTaskListResponse> {
		return new Promise<GetByPerformerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByPerformerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByPerformerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByPerformerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по тегам
	 */
	async getGroupedByTagTaskListAsync(request: GetGroupedByTagTaskListRequest): Promise<GetGroupedByTagTaskListResponse> {
		return new Promise<GetGroupedByTagTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByTagTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByTagTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByTagTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по тегу
	 */
	async getByTagTaskListAsync(request: GetByTagTaskListRequest): Promise<GetByTagTaskListResponse> {
		return new Promise<GetByTagTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByTagTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByTagTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByTagTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по типу
	 */
	async getGroupedByTypeTaskListAsync(request: GetGroupedByTypeTaskListRequest): Promise<GetGroupedByTypeTaskListResponse> {
		return new Promise<GetGroupedByTypeTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByTypeTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByTypeTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByTypeTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по типу
	 */
	async getByTypeTaskListAsync(request: GetByTypeTaskListRequest): Promise<GetByTypeTaskListResponse> {
		return new Promise<GetByTypeTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByTypeTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByTypeTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByTypeTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по владельцам
	 */
	async getGroupedByOwnerTaskListAsync(request: GetGroupedByOwnerTaskListRequest): Promise<GetGroupedByOwnerTaskListResponse> {
		return new Promise<GetGroupedByOwnerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByOwnerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByOwnerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByOwnerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по создателю
	 */
	async getByOwnerTaskListAsync(request: GetByOwnerTaskListRequest): Promise<GetByOwnerTaskListResponse> {
		return new Promise<GetByOwnerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByOwnerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByOwnerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByOwnerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение задач по родителю
	 */
	async getByParentTaskListAsync(request: GetByParentTaskListRequest): Promise<GetByParentTaskListResponse> {
		return new Promise<GetByParentTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByParentTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByParentTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByParentTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение детальной задачи
	 */
	async getByIdAsync(request: GetByIdRequest): Promise<GetByIdResponse> {
		return new Promise<GetByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}